import styled from 'styled-components'

const OfficeViewerStyled = styled.div``
export default OfficeViewerStyled
